import React from 'react';
var css = {
  "row": "rui-JOX86",
  "alignment-left": "rui-v22So",
  "alignment-center": "rui-3EPGi",
  "alignment-right": "rui-K4CfO",
  "valignment-top": "rui-D8cyt",
  "valignment-center": "rui-w0uzm",
  "valignment-bottom": "rui-qxQul",
  "direction-row": "rui-5xHoL",
  "direction-column": "rui-4omib"
};
import classNames from 'classnames';
var Row = function Row(_ref) {
  var children = _ref.children,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'left' : _ref$alignment,
    _ref$valignment = _ref.valignment,
    valignment = _ref$valignment === void 0 ? 'top' : _ref$valignment,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'row' : _ref$direction;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.row, css["alignment-".concat(alignment)], css["valignment-".concat(valignment)], css["direction-".concat(direction)])
  }, children);
};
export default Row;